<template>
  <div class="page-container">
    <div class="page-route-select">
      <router-link to="/cliente/monitores/cotacoes" class="page-route-select-text">
        Home
      </router-link>
      <span class="material-icons page-route-select-icon">play_arrow</span>
      <div class="page-route-select-text">Lista de Condições de Pagamento</div>
    </div>
    <div class="table-header">
      <div class="page-title">Lista de Condições de Pagamento</div>
      <button
        @click="addPayment()"
        :disabled="isAdding || editingExists"
        class="btn-add-primary"
      >
        <span class="material-icons-outlined">add</span>
        Nova Condição de Pagamento
      </button>
    </div>

    <div class="payment-container">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isAdding" class="adding-row">
            <td>Novo</td>
            <td>
              <input
                type="text"
                v-model="newPaymentName"
                placeholder="Condição de pagamento"
                @keyup.enter="saveNewPayment"
                class="input-new-payment"
                ref="nameInput"
              />
            </td>
            <td class="actions-column">
              <div class="action-buttons">
                <button @click="saveNewPayment" class="btn-save" :disabled="saving">
                  <span class="material-icons-outlined"> save </span>
                </button>
                <button @click="cancelAdd" class="btn-cancel" :disabled="saving">
                  <span class="material-icons-outlined"> cancel </span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-for="pagamento in formasDePagamento" :key="pagamento.id">
            <td>#{{ pagamento.id }}</td>
            <td>
              <span v-if="!pagamento.editing">{{ pagamento.name }}</span>
              <input
                v-else
                type="text"
                v-model="pagamento.editName"
                @keyup.enter="saveEdit(pagamento)"
                class="input-edit-payment"
              />
            </td>
            <td class="actions-column">
              <div class="action-buttons">
                <button
                  v-if="!pagamento.editing"
                  @click="startEdit(pagamento)"
                  :disabled="isAdding"
                  class="btn-edit"
                >
                  <span class="material-icons-outlined"> edit </span>
                </button>
                <button
                  v-else
                  @click="saveEdit(pagamento)"
                  :disabled="saving"
                  class="btn-save"
                >
                  <span class="material-icons-outlined"> save </span>
                </button>
                <button
                  @click="confirmDelete(pagamento)"
                  :disabled="isAdding || pagamento.editing"
                  class="btn-delete"
                >
                  <span class="material-icons-outlined"> delete </span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <Pagination
          classes="orange"
          :items_by_page_value="items_by_page_value"
          :total="meta && meta.total || 0"
          :page="currentPage"
          v-on:change="changePage($event)"
        />
      </div>
    </div>
    <div v-if="showConfirmModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Confirmação</h3>
        </div>
        <div class="modal-body">
          <p>{{ confirmMessage }}</p>
          <p v-if="confirmSubtitle" class="modal-subtitle">{{ confirmSubtitle }}</p>
        </div>
        <div class="modal-footer">
          <button @click="cancelDelete" class="btn-cancel">Cancelar</button>
          <button @click="executeDelete" class="btn-confirm" :disabled="saving">
            {{ saving ? "Excluindo..." : "Confirmar" }}
          </button>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="loading">
      <div class="cc-loader">
        <img src="/images/loader.svg" />
      </div>
    </div>
     <div v-if="error" class="error-message">
      {{ error }}
    </div>
    <div v-if="successMessage" class="success-message">
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import PaymentService from "@/services/v3/management/payment.service";
import Pagination from "@/components/cliente/base-components/Pagination.vue";
export default {
  name: "PaymentListing",
  components: {
    Pagination,
  },
  data() {
    return {
      formasDePagamento: [],
      isAdding: false,
      newPaymentName: "",
      loading: false,
      saving: false,
      error: null,
      paymentService: null,
      meta: null,
      currentPage: 1,
      items_by_page_value: 15,
      showConfirmModal: false,
      confirmMessage: "",
      confirmSubtitle: "",
      paymentToDelete: null,
      successMessage: null,
    };
  },
  computed: {
    editingExists() {
      return this.formasDePagamento.some((item) => item.editing);
    },
  },
  methods: {
    async loadPayment(page = 1) {
      this.loading = true;
      this.error = null;
      this.currentPage = page;

      try {
        const params = { page };
        const response = await this.paymentService.list(params);

        this.formasDePagamento = response.data.data.map((item) => ({
          ...item,
          editing: false,
          editName: item.name,
        }));
        this.meta = response.data.meta;
      } catch (error) {
        this.error = "Erro ao carregar as condições de pagamento.";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    addPayment() {
      this.isAdding = true;
      this.$nextTick(() => {
        if (this.$refs.nameInput) {
          this.$refs.nameInput.focus();
        }
      });
    },

    async saveNewPayment() {
      if (this.newPaymentName.trim() === "") {
        this.error = "A condição de pagamento não pode estar vazio.";
        return;
      }
      this.saving = true;
      this.error = null;
      try {
        const response = await this.paymentService.create({
          name: this.newPaymentName.trim(),
        });
        await this.loadPayment();
        this.cancelAdd();
        this.showSuccess("Condição de pagamento criada com sucesso!");
      } catch (error) {
        this.error = "Erro ao salvar nova forma de pagamento.";
        console.error(error);
      } finally {
        this.saving = false;
      }
    },

    cancelAdd() {
      this.isAdding = false;
      this.newPaymentName = "";
      this.error = null;
    },

    startEdit(pagamento) {
      this.formasDePagamento.forEach((item) => {
        if (item.editing && item.id !== pagamento.id) {
          item.editing = false;
          item.editName = item.name;
        }
      });

      pagamento.editing = true;
      pagamento.editName = pagamento.name;
    },

    async saveEdit(pagamento) {
      if (pagamento.editName.trim() === "") {
        this.error = "O nome do pagamento não pode estar vazio.";
        return;
      }

      this.saving = true;
      this.error = null;

      try {
        const response = await this.paymentService.update(pagamento.id, {
          name: pagamento.editName.trim(),
        });

        const index = this.formasDePagamento.findIndex(
          (item) => item.id === pagamento.id
        );
        if (index !== -1) {
          this.formasDePagamento[index] = {
            ...response.data,
            editing: false,
            editName: response.data.name,
          };
        }
        await this.loadPayment();
        this.showSuccess("Condição de pagamento atualizada com sucesso!");
      } catch (error) {
        this.error = "Erro ao salvar a forma de pagamento.";
        console.error(error);
      } finally {
        this.saving = false;
      }
    },

    confirmDelete(pagamento) {
      this.paymentToDelete = pagamento;
      this.confirmMessage = "Confirma a remoção da condição de pagamento?";
      this.confirmSubtitle = `"${pagamento.name}" será excluída permanentemente!`;
      this.showConfirmModal = true;
    },

    async executeDelete() {
      if (!this.paymentToDelete) return;

      this.saving = true;
      this.error = null;

      try {
        await this.paymentService.delete(this.paymentToDelete.id);
        await this.loadPayment();
        this.showSuccess("Condição de pagamento excluída com sucesso!");
        this.closeConfirmModal();
      } catch (error) {
        this.error = "Erro ao excluir a forma de pagamento.";
        console.error(error);
      } finally {
        this.saving = false;
      }
    },

    cancelDelete() {
      this.closeConfirmModal();
    },

    closeConfirmModal() {
      this.showConfirmModal = false;
      this.paymentToDelete = null;
      this.confirmMessage = "";
      this.confirmSubtitle = "";
    },

    showSuccess(message) {
      this.successMessage = message;
      setTimeout(() => {
        this.successMessage = null;
      }, 3000);
    },

    changePage(newPage) {
      this.loadPayment(newPage);
    },
  },
  mounted() {
    this.paymentService = new PaymentService();
    this.loadPayment();
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  margin-right: 4em;
}

.page-route-select {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.page-route-select-text {
  font-weight: 400;
  font-size: 1.36em;
  line-height: 17px;
  color: #ababab;
  margin-right: 20px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: var(--primary-color);
  }
}

.page-route-select-icon {
  color: var(--primary-color);
  margin-right: 20px;
}

.page-title {
  margin-top: 20px;
  font-weight: 700;
  font-size: 2em;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #605f5f;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid #ffcdd2;
}

.success-message {
  background-color: #e8f5e8;
  color: #2e7d32;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid #c8e6c9;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.payment-container {
  margin-top: 20px;
  overflow: hidden;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.btn-add-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;

  &:hover:not(:disabled) {
    background-color: #e65100;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

table {
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
    padding: 16px 20px;
    color: #605f5f;
    font-weight: 600;
    border-bottom: 1px solid #e0e0e0;
  }

  td {
    padding: 16px 16px;
    color: #424242;
  }

  .id-column {
    width: 100px;
    font-weight: 600;
    color: #757575;
  }

  .actions-column {
    width: 250px;
  }
}

.input-new-payment,
.input-edit-payment {
  width: 30%;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.2);
  }
}

.action-buttons {
  display: flex;
}

.btn-edit,
.btn-save,
.btn-delete,
.btn-cancel {
  border: none;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s;
  background: none;
}

.btn-save:disabled,
.btn-cancel:disabled,
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #9e9e9e;

  .material-icons-outlined {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.cc-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: white;
  gap: 10px;
}

.cc-loader img {
  width: 20px;
  height: 20px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 0;
  min-width: 400px;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  padding: 20px 24px 0;

  h3 {
    margin: 0;
    color: #333;
    font-size: 1.5em;
  }
}

.modal-body {
  padding: 20px 24px;

  p {
    margin: 0 0 8px 0;
    color: #666;
  }

  .modal-subtitle {
    font-weight: bold;
    color: #d32f2f;
  }
}

.modal-footer {
  padding: 0 24px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .btn-cancel {
    background-color: #f5f5f5;
    color: #333;

    &:hover {
      background-color: #e0e0e0;
    }
  }

  .btn-confirm {
    background-color: #d32f2f;
    color: white;

    &:hover:not(:disabled) {
      background-color: #c62828;
    }
  }
}

@media (max-width: 768px) {
  .page-container {
    margin-right: 0;
    padding: 0 0.5em;
  }

  .page-title {
    font-size: 1.5em;
    line-height: 1.3;
  }

  .page-route-select {
    margin-bottom: 15px;

    .page-route-select-text {
      font-size: 1.1em;
      margin-right: 10px;
    }

    .page-route-select-icon {
      margin-right: 10px;
    }
  }

  .table-header {
    flex-direction: column;
    gap: 10px;
  }

  .btn-add-primary {
    width: 80%;
    justify-content: center;
    padding: 12px 16px;
  }

  .action-buttons {
    justify-content: center;
  }

  .btn-edit,
  .btn-save,
  .btn-delete,
  .btn-cancel {
    padding: 8px 10px;
    font-size: 11px;
  }

  .success-message {
    top: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
  }

  .modal-content {
    min-width: unset;
    width: calc(100vw - 40px);
    margin: 0;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 15px 20px;
  }

  .modal-footer {
    justify-content: space-between;

    button {
      flex: 1;
      margin: 0 5px;
    }
  }

  table {
    min-width: 400px;

    th,
    td {
      padding: 8px 3px;
      font-size: 0.9em;
    }

    .actions-column {
      width: 200px;
      min-width: 200px;
    }
  }
}
</style>
